import styled from "styled-components";
const LoadingContainer = styled.div`
  padding: 20px;
  text-align: center;
  color: #666;
`;

export default LoadingContainer;
